import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, Phone, Mail, MapPin } from 'lucide-react';

const TermsConditions = () => {
  useEffect(() => { window.scrollTo(0, 0); }, []);

  return (
    <div className="min-h-screen bg-[#F9FAFB]">
      {/* Hero header */}
      <div className="bg-[#111827] relative overflow-hidden">
        <div className="max-w-7xl mx-auto px-6 md:px-8 pt-8 pb-16">
          <div className="flex items-center justify-between mb-12">
            <Link to="/">
              <span className="text-lg font-black tracking-tighter uppercase text-white" style={{ fontFamily: "'Outfit', sans-serif" }}>
                Trademark<span className="text-[#FF1010]">.</span>Agency
              </span>
            </Link>
            <Link to="/" className="flex items-center gap-2 text-sm text-white/60 hover:text-[#FF1010] transition-colors font-medium">
              <ArrowLeft className="w-4 h-4" />
              Back to Home
            </Link>
          </div>
          <div className="max-w-2xl">
            <span className="text-xs font-bold uppercase tracking-widest text-[#FF1010] block mb-3">Legal</span>
            <h1 className="text-4xl sm:text-5xl font-black text-white uppercase tracking-tighter leading-tight" style={{ fontFamily: "'Outfit', sans-serif" }}>
              Terms & Conditions
            </h1>
            <p className="text-sm text-white/40 mt-3">Last Updated: February 2026</p>
          </div>
        </div>
      </div>

      {/* Content */}
      <div className="max-w-4xl mx-auto px-6 md:px-8 py-16">
        <div className="space-y-10">
          <section>
            <div className="flex items-center gap-3 mb-4">
              <span className="w-8 h-8 bg-[#FF1010] flex items-center justify-center text-white font-black text-xs" style={{ fontFamily: "'Outfit', sans-serif" }}>01</span>
              <h2 className="text-base font-black text-[#111827] uppercase tracking-tight" style={{ fontFamily: "'Outfit', sans-serif" }}>Services</h2>
            </div>
            <p className="pl-11 text-sm text-[#4B5563] leading-relaxed">Trademark Agency USA provides professional trademark registration and USPTO filing services. By using our services, you agree to be bound by these Terms and Conditions. Our services include trademark search, application preparation, USPTO filing, office action response, and trademark monitoring.</p>
          </section>

          <div className="h-px bg-[#E5E7EB]" />

          <section>
            <div className="flex items-center gap-3 mb-4">
              <span className="w-8 h-8 bg-[#FF1010] flex items-center justify-center text-white font-black text-xs" style={{ fontFamily: "'Outfit', sans-serif" }}>02</span>
              <h2 className="text-base font-black text-[#111827] uppercase tracking-tight" style={{ fontFamily: "'Outfit', sans-serif" }}>Service Fees</h2>
            </div>
            <div className="pl-11 text-sm text-[#4B5563] leading-relaxed space-y-3">
              <p>Service fees are clearly listed on our website. Please note:</p>
              <ul className="list-none space-y-2">
                <li className="flex items-start gap-2"><span className="w-1.5 h-1.5 bg-[#FF1010] mt-1.5 flex-shrink-0" /><span>Government filing fees are separate and paid directly to the USPTO</span></li>
                <li className="flex items-start gap-2"><span className="w-1.5 h-1.5 bg-[#FF1010] mt-1.5 flex-shrink-0" /><span>All service fees are non-refundable once the application process has begun</span></li>
                <li className="flex items-start gap-2"><span className="w-1.5 h-1.5 bg-[#FF1010] mt-1.5 flex-shrink-0" /><span>Pricing is subject to change; quoted prices are honored for accepted engagements</span></li>
              </ul>
            </div>
          </section>

          <div className="h-px bg-[#E5E7EB]" />

          <section>
            <div className="flex items-center gap-3 mb-4">
              <span className="w-8 h-8 bg-[#FF1010] flex items-center justify-center text-white font-black text-xs" style={{ fontFamily: "'Outfit', sans-serif" }}>03</span>
              <h2 className="text-base font-black text-[#111827] uppercase tracking-tight" style={{ fontFamily: "'Outfit', sans-serif" }}>Client Responsibilities</h2>
            </div>
            <div className="pl-11 text-sm text-[#4B5563] leading-relaxed space-y-3">
              <p>As a client, you are responsible for:</p>
              <ul className="list-none space-y-2">
                <li className="flex items-start gap-2"><span className="w-1.5 h-1.5 bg-[#FF1010] mt-1.5 flex-shrink-0" /><span>Providing accurate and complete information for your trademark application</span></li>
                <li className="flex items-start gap-2"><span className="w-1.5 h-1.5 bg-[#FF1010] mt-1.5 flex-shrink-0" /><span>Responding promptly to requests for additional information or documentation</span></li>
                <li className="flex items-start gap-2"><span className="w-1.5 h-1.5 bg-[#FF1010] mt-1.5 flex-shrink-0" /><span>Ensuring you have the right to use the mark you wish to register</span></li>
              </ul>
              <p>Delays caused by incomplete or inaccurate information are not the responsibility of Trademark Agency USA.</p>
            </div>
          </section>

          <div className="h-px bg-[#E5E7EB]" />

          <section>
            <div className="flex items-center gap-3 mb-4">
              <span className="w-8 h-8 bg-[#FF1010] flex items-center justify-center text-white font-black text-xs" style={{ fontFamily: "'Outfit', sans-serif" }}>04</span>
              <h2 className="text-base font-black text-[#111827] uppercase tracking-tight" style={{ fontFamily: "'Outfit', sans-serif" }}>No Guarantee of Registration</h2>
            </div>
            <p className="pl-11 text-sm text-[#4B5563] leading-relaxed">While we maintain a 98% approval rate and strive for the highest success, trademark registration is ultimately subject to USPTO examination and approval. We cannot guarantee that every application will be approved. Our role is to prepare the strongest possible application and respond to any objections raised during the examination process.</p>
          </section>

          <div className="h-px bg-[#E5E7EB]" />

          <section>
            <div className="flex items-center gap-3 mb-4">
              <span className="w-8 h-8 bg-[#FF1010] flex items-center justify-center text-white font-black text-xs" style={{ fontFamily: "'Outfit', sans-serif" }}>05</span>
              <h2 className="text-base font-black text-[#111827] uppercase tracking-tight" style={{ fontFamily: "'Outfit', sans-serif" }}>Limitation of Liability</h2>
            </div>
            <p className="pl-11 text-sm text-[#4B5563] leading-relaxed">Trademark Agency USA liability is limited to the service fees paid for the specific service in question. We are not liable for any indirect, incidental, special, or consequential damages arising from the use of our services, including but not limited to lost profits, business interruption, or loss of data.</p>
          </section>

          <div className="h-px bg-[#E5E7EB]" />

          <section>
            <div className="flex items-center gap-3 mb-4">
              <span className="w-8 h-8 bg-[#FF1010] flex items-center justify-center text-white font-black text-xs" style={{ fontFamily: "'Outfit', sans-serif" }}>06</span>
              <h2 className="text-base font-black text-[#111827] uppercase tracking-tight" style={{ fontFamily: "'Outfit', sans-serif" }}>Intellectual Property</h2>
            </div>
            <p className="pl-11 text-sm text-[#4B5563] leading-relaxed">All content on this website, including text, graphics, logos, and software, is the property of Trademark Agency USA and protected by United States and international intellectual property laws. Unauthorized reproduction or distribution of any content is strictly prohibited.</p>
          </section>

          <div className="h-px bg-[#E5E7EB]" />

          <section>
            <div className="flex items-center gap-3 mb-4">
              <span className="w-8 h-8 bg-[#FF1010] flex items-center justify-center text-white font-black text-xs" style={{ fontFamily: "'Outfit', sans-serif" }}>07</span>
              <h2 className="text-base font-black text-[#111827] uppercase tracking-tight" style={{ fontFamily: "'Outfit', sans-serif" }}>Governing Law</h2>
            </div>
            <p className="pl-11 text-sm text-[#4B5563] leading-relaxed">These Terms and Conditions are governed by and construed in accordance with the laws of the State of California, United States. Any disputes arising under these terms shall be subject to the exclusive jurisdiction of the courts located in Fresno County, California.</p>
          </section>

          <div className="h-px bg-[#E5E7EB]" />

          <section>
            <div className="flex items-center gap-3 mb-4">
              <span className="w-8 h-8 bg-[#FF1010] flex items-center justify-center text-white font-black text-xs" style={{ fontFamily: "'Outfit', sans-serif" }}>08</span>
              <h2 className="text-base font-black text-[#111827] uppercase tracking-tight" style={{ fontFamily: "'Outfit', sans-serif" }}>Contact</h2>
            </div>
            <div className="pl-11 space-y-3">
              <p className="text-sm text-[#4B5563] leading-relaxed">For questions about these Terms and Conditions:</p>
              <div className="flex flex-col sm:flex-row gap-4">
                <a href="mailto:info@trademarkagencyusa.com" className="flex items-center gap-2 text-sm text-[#111827] font-semibold hover:text-[#FF1010] transition-colors">
                  <Mail className="w-4 h-4 text-[#FF1010]" /> info@trademarkagencyusa.com
                </a>
                <a href="tel:+18001234567" className="flex items-center gap-2 text-sm text-[#111827] font-semibold hover:text-[#FF1010] transition-colors">
                  <Phone className="w-4 h-4 text-[#FF1010]" /> +1 (800) 123-4567
                </a>
              </div>
              <div className="flex items-center gap-2 text-sm text-[#4B5563]">
                <MapPin className="w-4 h-4 text-[#FF1010]" /> 265 E River Park Cir Ste 110, Fresno, CA 93720
              </div>
            </div>
          </section>
        </div>
      </div>

      {/* Bottom bar */}
      <div className="border-t border-[#E5E7EB]">
        <div className="max-w-7xl mx-auto px-6 md:px-8 py-5 flex flex-col sm:flex-row justify-between items-center gap-3">
          <p className="text-xs text-[#9CA3AF]">&copy; {new Date().getFullYear()} Trademark Agency USA. All rights reserved.</p>
          <div className="flex gap-6 text-xs">
            <Link to="/privacy-policy" className="text-[#9CA3AF] hover:text-[#FF1010] transition-colors font-medium">Privacy Policy</Link>
            <Link to="/terms-conditions" className="text-[#FF1010] font-bold">Terms & Conditions</Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TermsConditions;
